export const MINISTRIES = {
  "lifeline-youth": {
    name: "Lifeline Youth Group",
    shortName: "Lifeline Youth",
    eyebrow: "Youth Ministry - Coming Soon",
    headline: "A LIFELINE FOR THE NEXT GENERATION.",
    intro:
      "Real hope for a generation that feels lost. Lifeline is where Clay County's middle and high school students will find faith that makes sense, friends that last, and mentors who actually listen - every Friday night.",
    meta: "Lifeline is Victory Chapel's youth ministry for middle and high school students in Clay County, Florida. Fridays at 7:00 PM, starting after our January 2027 launch - real hope, real friends, real faith.",
    artwork: "/ministry-lifeline.jpg",
    artworkAlt: "Lifeline Youth Group - a life ring hanging on a dock at sunset; real hope for a generation that feels lost",
    when: "Fridays at 7:00 PM (after launch)",
    who: "Middle & high school students",
    where: "3180 CR 220 STE 6-7, Middleburg",
    points: [
      "Real talk about real life - no lectures, no judgment",
      "Worship, games, and genuine friendship",
      "Mentors who actually listen",
      "A safe place to ask hard questions about God",
    ],
    closing: "Bring a friend. Leave with a family.",
  },
  "rally-point": {
    name: "The Rally Point",
    shortName: "The Rally Point",
    eyebrow: "Military Bible Study - Coming Soon",
    headline: "BE STRONG AND COURAGEOUS.",
    intro:
      "In the field, a rally point is where you regroup and find your bearings. The Rally Point is that place for your faith - a Bible study built for active duty, veterans, and military families in Clay County. Know. Grow. Go.",
    meta: "The Rally Point is Victory Chapel's military Bible study in Clay County, Florida - for active duty, veterans, and military families. Be strong and courageous. Joshua 1:9. Coming soon.",
    artwork: "/ministry-rally-point.jpg",
    artworkAlt: "The Rally Point military Bible study - a soldier silhouetted against a sunrise with an American flag; be strong and courageous, Joshua 1:9",
    when: "Meeting nights announced at launch",
    who: "Active duty, veterans & military families",
    where: "3180 CR 220 STE 6-7, Middleburg",
    points: [
      "Brotherhood and sisterhood that understands military life",
      "Straightforward Bible teaching - know, grow, go",
      "All branches, all ranks, all seasons of life",
      "Spouses and families always welcome",
    ],
    closing: "You never have to walk alone. Fall in with us.",
  },
  "in-home": {
    name: "Clay Groups",
    shortName: "Clay Groups",
    eyebrow: "Small Group Bible Study - Coming Soon",
    headline: "CLAY GROUPS.",
    intro:
      "\"For where two or three gather in my name, there am I with them.\" Clay Groups are where Victory Chapel gets personal - small groups meeting in living rooms across Clay County, sharing food, friendship, and faith. Know. Grow. Go.",
    meta: "Clay Groups are Victory Chapel Clay's in-home small group Bible studies across Clay County, Florida - real community, conversation, and discipleship for everyday life. Groups form after our January 2027 launch.",
    artwork: "/clay-groups.jpg",
    artworkAlt: "Clay Groups - Victory Chapel Clay's in-home small groups: real life, real community and connection, real answers",
    when: "Groups form after launch",
    who: "Anyone craving real community",
    where: "Homes across Clay County",
    points: [
      "Meet in homes across Clay County",
      "Conversation, not lecture",
      "Food, friendship, and faith around real tables",
      "Know - Grow - Go: discipleship for everyday life",
    ],
    closing: "There's a seat at a table near you.",
  },
};
